var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NoData"},[_c('img',{staticClass:"no-img",attrs:{"src":_vm.img}}),_c('p',{staticClass:"no-text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }